// Reconstructed from production code; original paths and local names were not available.
import { NavLink } from "react-router-dom";
import * as jsxRuntime from "react/jsx-runtime";
import { useAuth } from "../context/AuthContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useTheme } from "../context/ThemeContext.jsx";
const adminIcons = {
  DA: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <rect x={"3"} y={"3"} width={"7"} height={"9"} rx={"1"} />
      <rect x={"14"} y={"3"} width={"7"} height={"5"} rx={"1"} />
      <rect x={"14"} y={"12"} width={"7"} height={"9"} rx={"1"} />
      <rect x={"3"} y={"16"} width={"7"} height={"5"} rx={"1"} />
    </svg>
  ),
  VI: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M3 3v18h18"} />
      <path d={"m7 15 4-4 3 3 6-7"} />
      <path d={"M17 7h3v3"} />
    </svg>
  ),
  CS: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <rect x={"2"} y={"4"} width={"20"} height={"12"} rx={"2"} />
      <line x1={"2"} y1={"10"} x2={"22"} y2={"10"} />
      <line x1={"6"} y1={"14"} x2={"10"} y2={"14"} />
      <line x1={"18"} y1={"14"} x2={"18.01"} y2={"14"} />
      <path
        d={
          "M6 18h12a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2z"
        }
      />
    </svg>
  ),
  PR: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path
        d={
          "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
        }
      />
      <polyline points={"3.27 6.96 12 12.01 20.73 6.96"} />
      <line x1={"12"} y1={"22.08"} x2={"12"} y2={"12"} />
    </svg>
  ),
  CA: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M12 2L2 7l10 5 10-5-10-5z"} />
      <path d={"M2 17l10 5 10-5"} />
      <path d={"M2 12l10 5 10-5"} />
    </svg>
  ),
  CO: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"} />
      <line x1={"3"} y1={"6"} x2={"21"} y2={"6"} />
      <path d={"M16 10a4 4 0 0 1-8 0"} />
    </svg>
  ),
  CL: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"} />
      <circle cx={"9"} cy={"7"} r={"4"} />
      <path d={"M23 21v-2a4 4 0 0 0-3-3.87"} />
      <path d={"M16 3.13a4 4 0 0 1 0 7.75"} />
    </svg>
  ),
  US: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"} />
      <circle cx={"9"} cy={"7"} r={"4"} />
      <rect x={"16"} y={"11"} width={"6"} height={"8"} rx={"1"} />
      <path d={"M16 14a3 3 0 0 1 6 0"} />
    </svg>
  ),
  PA: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"} />
      <circle cx={"9"} cy={"7"} r={"4"} />
      <path d={"M19 8v6"} />
      <path d={"M22 11h-6"} />
    </svg>
  ),
  TH: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path
        d={
          "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 14.7255 3.09032 17.1962 4.85857 19C5.03444 19.1759 5.09938 19.4354 5.02102 19.6865C4.78775 20.4342 4.65625 21.2023 4.65625 22C4.65625 22.25 4.80625 22.5 5.05625 22.5H12Z"
        }
      />
      <circle cx={"7.5"} cy={"10.5"} r={"1.5"} />
      <circle cx={"11.5"} cy={"7.5"} r={"1.5"} />
      <circle cx={"16.5"} cy={"9.5"} r={"1.5"} />
      <circle cx={"15.5"} cy={"14.5"} r={"1.5"} />
    </svg>
  ),
  FO: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <rect x={"3"} y={"3"} width={"18"} height={"18"} rx={"2"} />
      <line x1={"3"} y1={"15"} x2={"21"} y2={"15"} />
      <line x1={"9"} y1={"15"} x2={"9"} y2={"21"} />
      <line x1={"15"} y1={"15"} x2={"15"} y2={"21"} />
    </svg>
  ),
  GO: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <path d={"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"} />
      <polyline points={"15 3 21 3 21 9"} />
      <line x1={"10"} y1={"14"} x2={"21"} y2={"3"} />
    </svg>
  ),
  KA: (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      width={"18"}
      height={"18"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
    >
      <circle cx={"9"} cy={"21"} r={"1"} />
      <circle cx={"20"} cy={"21"} r={"1"} />
      <path
        d={"M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"}
      />
    </svg>
  ),
};
function SidebarMenuIcon() {
  return (
    <svg
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"2"}
      strokeLinecap={"round"}
      aria-hidden={"true"}
    >
      <path d={"m6 6 12 12M18 6 6 18"} />
    </svg>
  );
}
const adminNavigation = [
  {
    key: "gestion",
    labelAR: "الإدارة",
    labelEN: "Management",
    items: [
      {
        to: "/admin/dashboard",
        icon: "DA",
        labelKey: "adminDashboard",
      },
      {
        to: "/admin/visitors",
        icon: "VI",
        labelKey: "adminVisits",
      },
      {
        to: "/admin/caisse",
        icon: "CS",
        labelKey: "adminCaisse",
      },
      {
        to: "/admin/products",
        icon: "PR",
        labelKey: "adminProducts",
      },
      {
        to: "/admin/categories",
        icon: "CA",
        labelKey: "adminCategories",
      },
      {
        to: "/admin/commandes",
        icon: "CO",
        labelKey: "adminCommandes",
      },
      {
        to: "/admin/clients",
        icon: "CL",
        labelKey: "adminClients",
      },
      {
        to: "/admin/users",
        icon: "US",
        labelKey: "adminUsers",
      },
      {
        to: "/admin/paniers",
        icon: "KA",
        labelKey: "adminPaniers",
      },
    ],
  },
  {
    key: "apparence",
    labelAR: "المظهر",
    labelEN: "Appearance",
    items: [
      {
        to: "/admin/partners",
        icon: "PA",
        labelKey: "adminPartners",
      },
      {
        to: "/admin/appearance",
        icon: "TH",
        labelKey: "adminAppearance",
      },
      {
        to: "/admin/footer",
        icon: "FO",
        labelKey: "adminFooter",
      },
    ],
  },
];
function AdminSidebar({
  isMobileOpen: l = false,
  onClose: onClose,
  onNavigate: onNavigate,
}) {
  const { user: user } = useAuth(),
    { theme: theme } = useTheme(),
    { t: t, language: language } = useLanguage(),
    y = theme?.site_name || "MyShop",
    g = language === "ar",
    p =
      user?.role === "CAISSE"
        ? [
            {
              key: "gestion",
              labelAR: "البيع",
              labelEN: "Sales",
              items: [
                {
                  to: "/admin/caisse",
                  icon: "CS",
                  labelKey: "adminCaisse",
                },
              ],
            },
          ]
        : adminNavigation;
  return (
    <aside
      id={"admin-mobile-navigation"}
      className={"admin-sidebar" + (l ? " is-mobile-open" : "")}
      role={l ? "dialog" : void 0}
      aria-modal={l || void 0}
      aria-label={g ? "تنقل الإدارة" : "Administration navigation"}
    >
      <button
        type={"button"}
        className={"admin-sidebar-close"}
        aria-label={g ? "إغلاق القائمة" : "Close navigation"}
        onClick={onClose}
      >
        <SidebarMenuIcon />
      </button>
      <div className={"admin-brand"}>
        <div className={"admin-brand-icon"}>
          {theme?.logo ? <img src={theme.logo} alt={y} /> : "MS"}
        </div>
        <div>
          <div className={"admin-brand-title"}>
            {y} {t("adminTitle")}
          </div>
          <div className={"admin-brand-subtitle"}>
            {g ? "مركز التحكم" : "Control Center"}
          </div>
        </div>
      </div>
      <nav className={"admin-menu"}>
        {p.map((b) => (
          <div className={"admin-menu-section"} key={b.key}>
            <div className={"admin-menu-group-label"}>
              {g ? b.labelAR : b.labelEN}
            </div>
            {b.items.map((x) => (
              <NavLink
                to={x.to}
                onClick={onNavigate}
                className={({ isActive: isActive }) =>
                  "admin-menu-item" + (isActive ? " active" : "")
                }
                key={x.to}
              >
                <span className={"admin-menu-icon"}>{adminIcons[x.icon]}</span>
                <span>{t(x.labelKey)}</span>
              </NavLink>
            ))}
          </div>
        ))}
        <div className={"admin-menu-section"}>
          <div className={"admin-menu-group-label"}>
            {g ? "الموقع" : "Site"}
          </div>
          <a href={"/"} className={"admin-menu-item"} onClick={onNavigate}>
            <span className={"admin-menu-icon"}>{adminIcons.GO}</span>
            <span>{g ? "عرض الموقع" : "View Site"}</span>
          </a>
        </div>
      </nav>
      <div className={"admin-sidebar-footer"}>
        <span className={"admin-sidebar-dot"} />
        <p>{g ? "نسخة اللوحة 1.0" : "Panel version 1.0"}</p>
      </div>
    </aside>
  );
}
export { adminIcons, SidebarMenuIcon, adminNavigation, AdminSidebar };
